// extracted by mini-css-extract-plugin
module.exports = {"Ribbon":"Ribbon_Ribbon__2g4V5","RibbonHot":"Ribbon_RibbonHot__358B2","RibbonSale":"Ribbon_RibbonSale__Rwi8z"};